import { createSelector } from "@reduxjs/toolkit";
import { SET_RANDOM_CURRENT_TRACK, SET_FINISHED_ALBUM, SET_LAST_SONG, SET_QUEUE_POINTER, SET_RANDOM_ALBUM_QUEUE, SET_RANDOM_MODE_ACTIVE, SET_SHOWING_QUEUE_DISPLAYER, SET_POINTED_RANDOM_ALBUM, SET_EDITING_QUEUE, SET_RANDOM_REPEAT_MODE, SET_FIRST_SONG } from "../actions/randomModeActions";
import { DEFAULT_RANDOM_REPEAT_MODE, RANDOM_REPEAT_MODES } from "../utils/constants/enumConstants";

export const getRandomModeActive = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.active
);

export const getPointedRandomAlbum = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.pointedRandomAlbum
);

export const getPreviousRandomAlbum = createSelector(
    state => state.randomModeState,
    randomModeState => {
        if(!randomModeState.randomAlbumQueue) return undefined;
        if(randomModeState.randomAlbumQueue.length === 0) return undefined;

        let queueIndex = randomModeState.queuePointer - 2;
        if(randomModeState.queuePointer <= 1)
        {
            queueIndex = randomModeState.randomRepeatMode !== RANDOM_REPEAT_MODES.off ?
                         randomModeState.randomAlbumQueue.length - 1 :
                         randomModeState.queuePointer - 1;
        }

        return randomModeState.randomAlbumQueue[queueIndex];
    }
);

export const getCurrentRandomAlbum = createSelector(
    state => state.randomModeState,
    randomModeState =>  randomModeState.randomAlbumQueue &&
                        randomModeState.randomAlbumQueue.length > 0 &&
                        randomModeState.queuePointer > 0 &&
                        randomModeState.randomAlbumQueue[randomModeState.queuePointer - 1]
);

export const getCurrentRandomTrack = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.currentTrack
);

export const getFirstSong = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.firstSong
);

export const getFirstSongId = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.firstSong && 
                        (
                            randomModeState.firstSong.linked_from ?
                            randomModeState.firstSong.linked_from.id :
                            randomModeState.firstSong.id
                        )
)

export const getLastSong = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.lastSong
);

export const getLastSongId = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.lastSong && 
                        (
                            randomModeState.lastSong.linked_from ?
                            randomModeState.lastSong.linked_from.id :
                            randomModeState.lastSong.id
                        )
);

export const isAlbumFinished = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.finishedAlbum
);

export const getQueue = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.randomAlbumQueue
);

export const getQueueLength = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.randomAlbumQueue.length
);

export const getQueuePointer = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.queuePointer
);

export const getRandomRepeatMode = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.randomRepeatMode
);

export const isRepeatModeOn = createSelector(
    state => state.randomModeState,
    randomModeState => randomModeState.randomRepeatMode !== RANDOM_REPEAT_MODES.off
);

export const isShowingQueueDisplayer = createSelector(
    state => state.randomModeState.queueDisplayer,
    queueDisplayer => queueDisplayer.showing
);

export const isEditingQueue = createSelector(
    state => state.randomModeState.queueDisplayer,
    queueDisplayer => queueDisplayer.editingQueue
);

const INITIAL_STATE = {
    active: false,
    randomAlbumQueue: [],
    pointedRandomAlbum: {
        album: undefined,
        trackUri: undefined,
        trackIndex: 0,
        positionMs: 0
    },
    queuePointer: 0,
    currentTrack: {
        uri: undefined,
        name: undefined
    },
    firstSong: undefined,
    lastSong: undefined,
    finishedAlbum: false,
    randomRepeatMode: DEFAULT_RANDOM_REPEAT_MODE,
    queueDisplayer: {
        showing: false,
        editingQueue: false
    }
}

export const randomModeState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_RANDOM_MODE_ACTIVE:
            return {...state, active: action.payload};
        case SET_RANDOM_ALBUM_QUEUE:
            return {...state, randomAlbumQueue: action.payload};
        case SET_POINTED_RANDOM_ALBUM:
            return {...state, pointedRandomAlbum: action.payload};
        case SET_QUEUE_POINTER:
            return {...state, queuePointer: action.payload};
        case SET_RANDOM_CURRENT_TRACK:
            return {...state, currentTrack: action.payload};
        case SET_FIRST_SONG:
            return {...state, firstSong: action.payload};
        case SET_LAST_SONG:
            return {...state, lastSong: action.payload};
        case SET_FINISHED_ALBUM:
            return {...state, finishedAlbum: action.payload};
        case SET_RANDOM_REPEAT_MODE:
            return {...state, randomRepeatMode: action.payload};
        case SET_SHOWING_QUEUE_DISPLAYER:
            return {...state, queueDisplayer: {...state.queueDisplayer, showing: action.payload}};
        case SET_EDITING_QUEUE:
            return {...state, queueDisplayer: {...state.queueDisplayer, editingQueue: action.payload}};
        default:
            return state;
    }
}